<div fxLayout="column" fxFlex="100" fxLayoutGap="10px">
    <app-members-tab-stars-user-details-analtics [userName]="userName" [selectedApp]="selectedApp"
    ></app-members-tab-stars-user-details-analtics>
<app-members-tab-stars-lesson-session-count-analtics [dateData$]="api.dateRange$"  [selectedApp]="selectedApp" [userName]="userName"
    ></app-members-tab-stars-lesson-session-count-analtics>
<app-stars-lessons-usage-graph-analtics #starsLessonsUsageGraphAnalticsComponent 
    [selectedApp]="selectedApp"
      [userName]="userName" [menuSelectedButton]="menuSelectedButton" 
    (emitAnalytics)="changeAnalytics($event)"
    (exportCsvEvent)="exportCsvData($event)"
    [sessionPlayedChartDatasets]="sessionPlayedChartDatasets"
    [sessionPlayedChartLabels]="sessionPlayedChartLabels"
    [updateChart]="updateChart"
  ></app-stars-lessons-usage-graph-analtics>
</div>

